import React from 'react';

import cn from './style.module.sass';

type StepsPropsType = {
    listSteps: { icon: string; text: string }[];
};
export default function Steps({ listSteps }: StepsPropsType) {
    return (
        <div className={cn.container}>
            {listSteps.map((item, index) => (
                <div key={index} className={cn.block}>
                    <img src={item.icon} alt="icon" className={cn.icon} />
                    <div className={cn.textBlock}>{item.text}</div>
                </div>
            ))}
        </div>
    );
}
